export const nsAccount = 'account';
export const nsBeneficiaries = 'beneficiaries';
export const nsContract = 'contract';
export const nsCustomization = 'customization';
export const nsEnvelope = 'envelope';
export const nsErrors = 'errors';
export const nsHistorics = 'historics';
export const nsHome = 'home';
export const nsLogin = 'login';
export const nsMerchantUser = 'merchantUser';
export const nsNotifRules = 'notifRules';
export const nsOrganization = 'organization';
export const nsPartners = 'partners';
export const nsPayluddSubscription = 'payluddSubscription';
export const nsPlan = 'plan';
export const nsPreLogin = 'preLogin';
export const nsRemoteCollection = 'remoteCollection';
export const nsSession = 'session';
export const nsSimCard = 'simCard';
export const nsSubscription = 'subscription';
export const nsTerminal = 'terminal';
export const nsUser = 'user';
export const nsZod = 'zod';
export const nsSearchContract = 'searchContract';
export const nsDashboard = 'dashboard';
export const nsNewsletter = 'newsletter';